import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 rounded-lg bg-accent-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-xl"></i>
            </div>
            <span className="text-xl font-bold text-foreground-950 tracking-tight">
              桃子视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive("/")
                  ? "text-accent-500"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith("/category")
                  ? "text-accent-500"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive("/about")
                  ? "text-accent-500"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-4">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索影视资源..."
                className="w-56 pl-9 pr-4 py-2 text-sm rounded-full border border-background-200 bg-background-100 text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-200 transition-all"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 flex flex-col gap-3">
            <div className="mb-2">
              <input
                type="text"
                placeholder="搜索影视资源..."
                className="w-full pl-9 pr-4 py-2.5 text-sm rounded-full border border-background-200 bg-background-100 text-foreground-950 placeholder-foreground-400 focus:outline-none focus:border-accent-400"
              />
              <i className="ri-search-line absolute ml-3 -mt-8 text-foreground-400 text-sm"></i>
            </div>
            <Link
              to="/"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive("/") ? "bg-accent-100 text-accent-600" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname.startsWith("/category") ? "bg-accent-100 text-accent-600" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive("/about") ? "bg-accent-100 text-accent-600" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}